/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис упраления связями помещений и устройств
 */

/**
 * Сервис управления связями помещений и устройств
 */
export class RoomDeviceServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод создания связи помещения и устройства.
   * Метод доступен для: admin, service
   */
  PutRoomDeviceAttach = (req: PutRoomDeviceAttachRequestDto, init?: RequestInit): Promise<PutRoomDeviceAttachResponseDto> => {
    return fm.request<PutRoomDeviceAttachRequestDto, PutRoomDeviceAttachResponseDto>(`${this.host}/access_control/api/v1/room/${encodeURIComponent(req.roomDevice.orpon)}/${encodeURIComponent(req.roomDevice.roomNumber)}/device/${encodeURIComponent(req.roomDevice.deviceId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связи помещения и устройства.
   * Метод доступен для: admin, service
   */
  PutRoomDeviceDetach = (req: PutRoomDeviceDetachRequestDto, init?: RequestInit): Promise<PutRoomDeviceDetachResponseDto> => {
    return fm.request<PutRoomDeviceDetachRequestDto, PutRoomDeviceDetachResponseDto>(`${this.host}/access_control/api/v1/room/${encodeURIComponent(req.roomDevice.orpon)}/${encodeURIComponent(req.roomDevice.roomNumber)}/device/${encodeURIComponent(req.roomDevice.deviceId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связок помещение-устройство.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  GetRoomDeviceList = (req?: GetRoomDeviceListRequestDto, init?: RequestInit): Promise<GetRoomDeviceListResponseDto[]> => {
    return fm.list<GetRoomDeviceListRequestDto, GetRoomDeviceListResponseDto>(`${this.host}/access_control/api/v1/room/device/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связок помещение-устройство.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  GetRoomDeviceCount = (req: GetRoomDeviceCountRequestDto, init?: RequestInit): Promise<GetRoomDeviceCountResponseDto> => {
    return fm.request<GetRoomDeviceCountRequestDto, GetRoomDeviceCountResponseDto>(`${this.host}/access_control/api/v1/room/device/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 */
export enum RoomDevicePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type RoomDevicePagingDirectionTypeResponseEnum = keyof typeof RoomDevicePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type RoomDevicePagingDirectionTypeRequestEnum = Exclude<RoomDevicePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum RoomDevicePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По ОРПОНу и номеру подъезда
   */
  ORPON_THEN_ENTRANCE_NUMBER = "ORPON_THEN_ENTRANCE_NUMBER",
  /**
   * По идентификатору устройства
   */
  DEVICE_ID = "DEVICE_ID",
}
/**
 * Справочник типов значений сортировки.
 */
export type RoomDevicePagingOrderByTypeResponseEnum = keyof typeof RoomDevicePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type RoomDevicePagingOrderByTypeRequestEnum = Exclude<RoomDevicePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества домов
 */
export type GetRoomDeviceCountRequestDto = {
  /**
   * Фильтр
   */
  filter: RoomDeviceFilterRequestDto
}
/**
 * Ответ на запрос получения количества домов
 */
export type GetRoomDeviceCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
}>
/**
 * Запрос на получение связок помещение-устройство
 */
export type GetRoomDeviceListRequestDto = {
  /**
   * Фильтр по связкам помещение-устройство
   */
  filter?: RoomDeviceFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: RoomDevicePagingRequestDto
}>
/**
 * Ответ на запрос на получение списка связок помещение-устройство
 */
export type GetRoomDeviceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связка помещение-устройство
   */
  readonly data: RoomDeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: GetRoomDeviceListResponseErrorDto
}>
/**
 * Ошибка запроса на получение списка связок помещение-устройство
 */
export type GetRoomDeviceListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение списка связок помещение-устройство
 */
export type GetRoomDeviceListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос создания связи квартиры и устройства
 */
export type PutRoomDeviceAttachRequestDto = {
  /**
   * Связь квартиры и устройства
   */
  roomDevice: RoomDeviceRequestDto
}
/**
 * Ответ на запрос сохранения связи квартиры и устройства
 */
export type PutRoomDeviceAttachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutRoomDeviceAttachResponseErrorDto
}>
/**
 * Ошибка запроса на создание связи квартиры и устройства
 */
export type PutRoomDeviceAttachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на создание связи квартиры и устройства
 */
export type PutRoomDeviceAttachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос удаления связи квартиры и устройства
 */
export type PutRoomDeviceDetachRequestDto = {
  /**
   * Связь квартиры и устройства
   */
  roomDevice: RoomDeviceRequestDto
}
/**
 * Ответ на запрос удаления связи квартиры и устройства
 */
export type PutRoomDeviceDetachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutRoomDeviceDetachResponseErrorDto
}>
/**
 * Ошибка запроса на удаления связи квартиры и устройства
 */
export type PutRoomDeviceDetachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на удаления связи квартиры и устройства
 */
export type PutRoomDeviceDetachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Связка квартиры и устройства
 */
export type RoomDeviceRequestDto = {
  /**
   * Идентификатор ОРПОН дома.
   * # Диапазон 1..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
  /**
   * Идентификатор устройства.
   * # Диапазон: 1..2147483647
   */
  deviceId: number
}
/**
 * Связка квартиры и устройства
 */
export type RoomDeviceResponseDto = {
  /**
   * Идентификатор ОРПОН дома.
   * # Диапазон 1..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
  /**
   * Идентификатор устройства.
   * # Диапазон: 1..2147483647
   */
  deviceId: number
}
/**
 * Фильтр связок помещение-устройство
 */
export type RoomDeviceFilterRequestDto = {
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds?: number[]
  /**
   * По ОРПОН
   */
  orpons?: string[]
  /**
   * По номерам квартир
   */
  roomNumbers?: string[]
  /**
   * По идентификаторам привязанных устройств
   */
  deviceIds?: number[]
}
/**
 * Фильтр связок помещение-устройство
 */
export type RoomDeviceFilterResponseDto = {
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds: number[]
  /**
   * По ОРПОН
   */
  orpons: string[]
  /**
   * По номерам квартир
   */
  roomNumbers: string[]
  /**
   * По идентификаторам привязанных устройств
   */
  deviceIds: number[]
}
/**
 * Постраничный вывод
 */
export type RoomDevicePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
   */
  orderByType?: RoomDevicePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: RoomDevicePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type RoomDevicePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
   */
  orderByType: RoomDevicePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: RoomDevicePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества домов
   */
  "GetRoomDeviceCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества домов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RoomDeviceFilter",
        "text": "Фильтр",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения количества домов
   */
  "GetRoomDeviceCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества домов",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
    },
  },
  /**
   * Запрос на получение связок помещение-устройство
   */
  "GetRoomDeviceListRequest": {
    "kind": "class",
    "text": "Запрос на получение связок помещение-устройство",
    "fields": {
      /**
       * Фильтр по связкам помещение-устройство
       */
      "filter": {
        "type": "RoomDeviceFilter",
        "text": "Фильтр по связкам помещение-устройство",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "RoomDevicePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос на получение списка связок помещение-устройство
   */
  "GetRoomDeviceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение списка связок помещение-устройство",
    "fields": {
      /**
       * Связка помещение-устройство
       */
      "data": {
        "type": "RoomDevice",
        "text": "Связка помещение-устройство",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRoomDeviceListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение списка связок помещение-устройство
   */
  "GetRoomDeviceListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение списка связок помещение-устройство",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос создания связи квартиры и устройства
   */
  "PutRoomDeviceAttachRequest": {
    "kind": "class",
    "text": "Запрос создания связи квартиры и устройства",
    "fields": {
      /**
       * Связь квартиры и устройства
       */
      "roomDevice": {
        "type": "RoomDevice",
        "text": "Связь квартиры и устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи квартиры и устройства
   */
  "PutRoomDeviceAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи квартиры и устройства",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutRoomDeviceAttachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на создание связи квартиры и устройства
   */
  "PutRoomDeviceAttachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на создание связи квартиры и устройства",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос удаления связи квартиры и устройства
   */
  "PutRoomDeviceDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связи квартиры и устройства",
    "fields": {
      /**
       * Связь квартиры и устройства
       */
      "roomDevice": {
        "type": "RoomDevice",
        "text": "Связь квартиры и устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи квартиры и устройства
   */
  "PutRoomDeviceDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи квартиры и устройства",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutRoomDeviceDetachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на удаления связи квартиры и устройства
   */
  "PutRoomDeviceDetachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на удаления связи квартиры и устройства",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Связка квартиры и устройства
   */
  "RoomDevice": {
    "kind": "class",
    "text": "Связка квартиры и устройства",
    "fields": {
      /**
       * Идентификатор ОРПОН дома.
       * # Диапазон 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома.\n# Диапазон 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..4
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..4",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
      /**
       * Идентификатор устройства.
       * # Диапазон: 1..2147483647
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Фильтр связок помещение-устройство
   */
  "RoomDeviceFilter": {
    "kind": "class",
    "text": "Фильтр связок помещение-устройство",
    "fields": {
      /**
       * По идентификаторам квартирограмм
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "По идентификаторам квартирограмм",
      },
      /**
       * По ОРПОН
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОН",
      },
      /**
       * По номерам квартир
       */
      "roomNumbers": {
        "type": "string",
        "text": "По номерам квартир",
      },
      /**
       * По идентификаторам привязанных устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам привязанных устройств",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "RoomDevicePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
       */
      "orderByType": {
        "type": "RoomDevicePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: ORPON_THEN_ENTRANCE_NUMBER",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "RoomDevicePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "RoomDevicePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "RoomDevicePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По ОРПОНу и номеру подъезда
       */
      "ORPON_THEN_ENTRANCE_NUMBER": {
        "i": 1,
        "text": "По ОРПОНу и номеру подъезда",
      },
      /**
       * По идентификатору устройства
       */
      "DEVICE_ID": {
        "i": 2,
        "text": "По идентификатору устройства",
      },
    },
  },
}